<template>
  <div class="div_principal">
    <div class="div_imagem"></div>
    <div class="div_login">
      <img src="/images/demode.png" id="logo" />

      <div class="formulario">
        <div class="inputContainer">
          <label>Usuário</label>
          <input type="text" class="input" v-model="state.email" />
        </div>
        <div class="inputContainer">
          <label>Senha</label>
          <input type="password" class="input" v-model="state.password" />
        </div>
        <button type="button" class="btn_entrar" @click="logar()">
          Entrar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import services from "../../services";
//import { useField } from "vee-validate";
import { useRouter } from "vue-router";
import { useStorage } from "vue3-storage";
/*
const body = document.getElementsByTagName("body")[0];
*/
export default {
  setup() {
    const state = reactive({
      email: "",
      password: "",
    });
    const router = useRouter();
    const storage = useStorage();
    async function logar() {
      if (
        state.email == null ||
        state.email == undefined ||
        state.email == ""
      ) {
        alert("Insira um Email!");
      }
      if (
        state.password == null ||
        state.password == undefined ||
        state.password == ""
      ) {
        alert("Insira uma Senha!");
        return;
      }
      try {
        const { data } = await services.clientes.login({
          email: state.email,
          password: state.password,
        });
        if (data) {
          storage.setStorageSync("cliente_token", data.token);
          storage.setStorageSync("nome", data.nome);
          storage.setStorageSync("cliente_id", data.cliente.id);
          storage.setStorageSync(
            "application_id",
            data.cliente.usuario_mercado_livre.application_id
          );
          router.push("/dashboard/pagina-inicial");
        }
      } catch (error) {
        console.log(error);
      }
    }
    return {
      state,
      logar,
    };
  } /*
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },*/,
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.div_imagem {
  background-image: url("/images/smart_login.png");
  width: 70%;
  height: 100vh;
  float: left;
  background-size: 100% 100%;
}

.pi-eye {
  transform: scale(1.6);
  margin-right: 1rem;
}

.pi-eye-slash {
  transform: scale(1.6);
  margin-right: 1rem;
}

#app {
  height: 100%;
}

.div_principal {
  background-color: #fef9ff !important;
  height: 100vh;
}

.div_login {
  background-color: #fef9ff;
  float: left;
  width: 30%;
  text-align: center;
  padding-top: 100px;
}

#logo {
  width: 50%;
}

.input {
  width: 100%;
}

.btn_entrar {
  width: 80%;
  background-color: #560382;
  color: #fff;
  padding: 9px;
  border: none;
  border-radius: 5px;
  font-size: 12pt;
  font-weight: bold;
}

.inputContainer {
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 10px;
  width: 80%;
}

.formulario {
  margin-top: 46px;
  text-align: center;
}

input {
  border: #efefef solid 1px !important;
  background-color: #fbfbfb !important;
  padding: 13px;
  font-size: 11pt;
  margin-bottom: 5px;
  margin-top: 5px;
}

button {
  margin-top: 40px;
  cursor: pointer;
}

label {
  font-size: 12pt;
  font-weight: bold;
  margin-bottom: 0;
}

a {
  color: #560382 !important;
  font-weight: 400;
  font-size: 10pt;
}

.conta {
  font-size: 10pt;
}

@media (min-width: 576px) and (max-width: 767px) {
  .div_imagem {
    background-image: url("/images/smart_login.png");
    width: 70%;
    height: 100vh;
    float: left;
    background-size: cover;
    background-position: center;
  }
}

@media screen and (max-width: 575px) {
  .div_imagem {
    display: none;
  }

  .div_login {
    width: 100%;
  }
}
</style>
